function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?minimize!../../../../../../develop/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-eacd8cfc\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../../develop/node_modules/vue-loader/lib/selector?type=styles&index=0!./OrderList.vue")
  require("!!vue-style-loader!css-loader?minimize!../../../../../../develop/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-eacd8cfc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../develop/node_modules/vue-loader/lib/selector?type=styles&index=1!./OrderList.vue")
}
var Component = require("!../../../../../../develop/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../develop/node_modules/vue-loader/lib/selector?type=script&index=0!./OrderList.vue"),
  /* template */
  require("!!../../../../../../develop/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-eacd8cfc\",\"hasScoped\":true}!../../../../../../develop/node_modules/vue-loader/lib/selector?type=template&index=0!./OrderList.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-eacd8cfc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/OrderList.vue
// module id = 405
// module chunks = 0